// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag[data-v-f98ec55c]{color:rgba(0,0,0,.6);display:block;font-size:12px;height:20px;letter-spacing:1px;line-height:20px;margin-bottom:8px;position:relative;text-align:center;text-transform:uppercase}.widget[data-v-f98ec55c]{margin:0 auto}.ltk-comm-widget-mob[data-v-f98ec55c]{height:250px;width:300px}.ltk-comm-widget-dt[data-v-f98ec55c]{height:250px;width:265px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
